export default "__VITE_ASSET__DaQtyCm9__"